// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"31":"4844e6f0","94":"01c55fe8","100":"d9c607d9","224":"7fbe198c","287":"61a4e63e","317":"a1cc2387","453":"e3f6aeff","468":"074ae721","528":"6bb860ea","537":"48ab8537","627":"9fe02c8a","774":"58661422","834":"3af867cf","850":"f1517f8a","968":"7d117dd8"}[chunkId] + ".chunk.js";
};